import { env } from "utils/env";

/*
 * The Sidekiq web UI is a Rack app mounted on the RAILS server behind the
 * superadmin route-constraint at `<rails-origin>/sidekiq` — it can't be
 * React-rendered, so the admin section links out to it rather than
 * reimplementing it.
 *
 * VITE_API_ROOT is the rails API base WITH its `/api` path (e.g.
 * `https://staging.mvbth.com/api`). Sidekiq lives at the ORIGIN, not under
 * `/api`, so we take the origin and append `/sidekiq`. Returns null when the
 * API root is unset or unparseable, so callers can hide the link rather than
 * render a broken one.
 */
export const sidekiqUrl = () => {
  const apiRoot = env.VITE_API_ROOT;
  if (!apiRoot) return null;
  try {
    return `${new URL(apiRoot).origin}/sidekiq`;
  } catch {
    return null;
  }
};
